import {Component, EventEmitter, Input, OnInit, Output, signal} from '@angular/core';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {NgComponentOutlet, NgTemplateOutlet} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

export interface TabItem {
  id: string;
  label: string;
  component?: any;
  template?: any;
  content?: string;
}

@Component({
  selector: 'app-tabs',
  standalone: true,
  templateUrl: './tabs-dynamic.html',
  imports: [
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    NgTemplateOutlet,
    NgComponentOutlet,
    Tabs,
    TranslatePipe,
  ],
  styleUrls: ['./tabs-dynamic.scss']
})

export class TabsDynamic implements OnInit {
  tabWidth = signal(0);

  @Input() tabs: TabItem[] = [];
  @Input() activeTab: string = '';
  @Output() tabChanged = new EventEmitter<string>();

  ngOnInit() {
    if (!this.activeTab && this.tabs.length > 0) {
      this.activeTab = this.tabs[0].id;
    }
    this.tabWidth.set(100 / this.tabs.length);
  }

  onTabChange(value: any) {
    this.activeTab = value;
    this.tabChanged.emit(value);
  }
}
